import {
  OWNER_JARVIS_API_OPERATION_POLICIES,
  ownerJarvisApiMethodIsSensitive,
  ownerJarvisOperationPolicyForApiMethod,
} from "./ownerJarvisOperationPolicy";

function sensitiveWriteBlockedError(method) {
  const error = new Error(`La mutación sensible ${String(method)} requiere confirmación explícita de Jarvis.`);
  error.code = "JARVIS_SENSITIVE_CONFIRMATION_REQUIRED";
  return error;
}

export function ownerJarvisSnapshotScopesForMutation(method) {
  return ownerJarvisOperationPolicyForApiMethod(method)?.scopes || null;
}

export function createOwnerJarvisMutationAwareApi({ ownerApi, snapshotService } = {}) {
  const wrapped = new Map();

  const runMutation = async (method, args) => {
    const value = ownerApi?.[method];
    if (typeof value !== "function") throw new Error(`Método Owner inexistente: ${String(method)}`);
    const result = await value.apply(ownerApi, args);
    const scopes = ownerJarvisSnapshotScopesForMutation(method);
    if (scopes?.length) snapshotService?.invalidate?.(scopes);
    return result;
  };

  const executeSensitive = async (method, ...args) => {
    if (!ownerJarvisApiMethodIsSensitive(method)) throw sensitiveWriteBlockedError(method);
    return runMutation(method, args);
  };

  return new Proxy(ownerApi, {
    get(target, property, receiver) {
      if (property === "executeSensitive") return executeSensitive;
      if (property === "operationPolicy") return ownerJarvisOperationPolicyForApiMethod;

      const value = Reflect.get(target, property, receiver);
      const policy = ownerJarvisOperationPolicyForApiMethod(property);
      if (typeof value !== "function" || policy == null) return value;
      if (wrapped.has(property)) return wrapped.get(property);

      if (policy.kind === "sensitive_write") {
        const blocked = async () => { throw sensitiveWriteBlockedError(property); };
        wrapped.set(property, blocked);
        return blocked;
      }

      const mutation = async (...args) => runMutation(property, args);
      wrapped.set(property, mutation);
      return mutation;
    },
  });
}

export const OWNER_JARVIS_SNAPSHOT_MUTATION_METHODS = new Set(Object.keys(OWNER_JARVIS_API_OPERATION_POLICIES));
export const OWNER_JARVIS_MUTATION_SCOPE_MAP = Object.freeze(Object.fromEntries(
  Object.entries(OWNER_JARVIS_API_OPERATION_POLICIES).map(([method, policy]) => [method, [...(policy.scopes || [])]]),
));
